import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  presences: {},
};

const presenceSlice = createSlice({
  name: 'presence',
  initialState,
  reducers: {
    setPresences: (state, action) => {
      state.presences = action.payload || {};
    },
    resetPresence: () => initialState,
  },
});

export const { setPresences, resetPresence } = presenceSlice.actions;

export const selectPresences = (state) => state.presence.presences;
export const selectUserPresence = (userId) => (state) =>
  state.presence.presences[userId] ?? null;
export const selectOnlineUserIds = (state) =>
  Object.keys(state.presence.presences);
export const selectUsersOnPath = (path) => (state) => {
  const presences = state.presence.presences;
  return Object.entries(presences)
    .filter(([, data]) => {
      if (typeof data === 'string') return data === path;
      return data?.pathId === path;
    })
    .map(([uid, data]) => ({
      uid,
      displayName: typeof data === 'string' ? null : data?.displayName,
      avatar: typeof data === 'string' ? null : data?.avatar,
    }));
};

export default presenceSlice.reducer;
